<template>
  <UModal class="max-w-[400px]">
    <template #header>
      <div class="flex gap-3 items-center">
        <UIcon name="lucide:file-spreadsheet" class="size-6 text-muted" />
        <span class="text-xl uppercase text-muted">Link Production Plan</span>
      </div>
    </template>

    <template #body>
      <UInput
        v-model="productionPlanUrl"
        label="Production Plan Url"
        placeholder="https://example.com/production-plan"
        size="lg"
        class="w-full"
      />
    </template>

    <template #footer>
      <div class="flex gap-3 items-center justify-end w-full">
        <UButton
          color="neutral"
          :active="isValidProductionPlanUrl"
          :disabled="!isValidProductionPlanUrl"
          active-color="success"
          variant="soft"
          icon="lucide:file-plus-2"
          label="add"
          :loading="loading"
          @click="onAddProductionPlanClick"
        />
      </div>
    </template>
  </UModal>
</template>

<script lang="ts" setup>
import * as z from "zod";

const schema = z.object({
  productionPlanUrl: z.url(),
});

const isValidProductionPlanUrl = computed(() => {
  return schema.safeParse({ productionPlanUrl: productionPlanUrl.value })
    .success;
});

const productionPlanUrl = ref("");

const loading = ref(false);

const props = defineProps<{ campaign: Campaign }>();

const emit = defineEmits(["close"]);

const { $api } = useNuxtApp();

const onAddProductionPlanClick = async () => {
  loading.value = true;
  try {
    const response = await $api(`/campaign/${props.campaign.id}`, {
      method: "PATCH",
      body: {
        productionPlanUrl: productionPlanUrl.value,
      },
    });

    emit("close", true);
  } catch (error) {
    console.error(error);
  } finally {
    loading.value = false;
  }
};
</script>

<style></style>
